import { AxiosResponse } from 'axios'
import Request from 'redux/config/services/Request'
import { ScheduledReport } from './automatedReportingTypes'

const getScheduledReports = (): Promise<AxiosResponse> => {
  return Request.get('/hr/reporting/scheduled_reports/')
}

const getScheduledReportRuns = (): Promise<AxiosResponse> => {
  return Request.get('/hr/reporting/scheduled_report_runs/')
}

const createScheduledReport = (
  scheduledReport: ScheduledReport
): Promise<AxiosResponse> => {
  return Request.post('/hr/reporting/scheduled_reports/', scheduledReport)
}

const updateScheduledReport = ({
  id,
  dayOfMonth,
  segmentNames,
  ...scheduledReport
}: ScheduledReport): Promise<AxiosResponse> => {
  return Request.patch(`/hr/reporting/scheduled_reports/${id}/`, scheduledReport)
}

export default {
  getScheduledReports,
  getScheduledReportRuns,
  createScheduledReport,
  updateScheduledReport,
}
